import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { useUserStore } from '@tshared/stores/user.store'

import '@/routes/arc/-styles/index.scss'
import { Spin } from 'antd'

import { BackgroundTask } from '@/routes/arc/-widgets/arc-background-task/BackgroundTask.tsx'
import ArcHeader from '@/routes/arc/-widgets/arc-header/ArcHeader.tsx'
import OperatorStatusUpdateForm from '@/routes/arc/-widgets/operator-status-update-form/OperatorStatusUpdateForm.tsx'
import RejectCallReasonForm from '@/routes/arc/-widgets/reject-call-form/RejectCallReasonForm.tsx'
import { useHostInitialized } from '@/stores/host.store.tsx'
import { Host } from '@/widgets/hosts/Host.tsx'

export const Route = createFileRoute('/arc')({
  component: Layout,
  beforeLoad: async () => {
    // check user auth
    const user = useUserStore.getState().user
    if (!user?.accessToken) {
      return redirect({
        to: '/auth/sign-in',
        search: { redirect: location.pathname + location.search },
      })
    }
    return
  },
})

function Layout() {
  const initialized = useHostInitialized()

  return (
    <>
      <div className={'arc-page'}>
        <ArcHeader />
        {initialized ? (
          <Outlet />
        ) : (
          <div className={'flex h-screen items-center justify-center'}>
            <Spin size={'large'} />
          </div>
        )}
        <OperatorStatusUpdateForm />
        <RejectCallReasonForm />
      </div>
      <BackgroundTask />
      <Host />
    </>
  )
}
